/* projects/speaker-platform/src/app/pages/admin/global-planning/global-planning.component.scss */
.globalplanning__week__day__details {
  display: grid;
  grid-template-columns: 2fr 1fr;
  column-gap: 16px;
}
.globalplanning__week__day__details__aside {
  display: flex;
  flex-direction: column;
}
.globalplanning__week__day__details__item {
  position: relative;
  padding: 12px 16px;
  margin-bottom: 16px;
  background-color: #FAF8F4;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0px 5px 15px -2px rgba(0, 0, 0, 0.38);
}
.globalplanning__week__day__details__item ul {
  list-style: none;
  padding: 0;
  columns: 2;
  column-gap: 16px;
}
.globalplanning__week__day__details__aside .globalplanning__week__day__details__item ul {
  columns: 1;
}
.globalplanning__week__day__details .subLegend {
  color: #8d8d8d;
  font-size: 14px;
  font-style: italic;
  margin-bottom: 8px;
  column-span: all;
}
.globalplanning__week__day__header {
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 700;
}
.globalplanning__speakerslist {
  height: 70vh;
  overflow-y: scroll;
}
.globalplanning__defaultlist {
  list-style: none;
  padding: 0;
}
.globalplanning__alldefaultsbutton {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 0;
  background-color: #74E4FD;
  color: #dadada;
}
/*# sourceMappingURL=global-planning.component-PX7V7Q5R.css.map */
